import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class ExpoBrandApi {
  getExpoBrands = async (params) => {
    try {
      const response = await api.get("expo-brand", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Expo Brands. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getExpoBrandById = async (id) => {
    try {
      const response = await api.get(`expo-brand/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Expo Brand details. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  saveExpoBrand = async (data) => {
    try {
      const response = await api.post("/expo-brand", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Save Expo Brand. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  updateExpoBrand = async (id, data) => {
    try {
      const response = await api.put(`/expo-brand/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Update Expo Brand. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  deleteExpoBrand = async (id) => {
    try {
      const response = await api.delete(`/expo-brand/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Delete Expo Brand. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };
}

const expoBrandApi = new ExpoBrandApi();
export default expoBrandApi;

export const { getExpoBrands, getExpoBrandById, saveExpoBrand, updateExpoBrand, deleteExpoBrand } = expoBrandApi;
